import { render, staticRenderFns } from "./ParticipantsAndRecommendations.html?vue&type=template&id=af050b24&scoped=true&lang=html&"
import script from "./ParticipantsAndRecommendations.js?vue&type=script&lang=js&"
export * from "./ParticipantsAndRecommendations.js?vue&type=script&lang=js&"
import style0 from "./ParticipantsAndRecommendations.css?vue&type=style&index=0&id=af050b24&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af050b24",
  null
  
)

export default component.exports